import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld';
import PersonReport from '@/views/report/PersonReport';
import RegionReport from '@/views/report/RegionReport';
import Content from '@/views/agreement/Content'
import ContentEmployees from '@/views/agreement/content-employees';
import ContentOwner from '@/views/agreement/content-owner';
import newsbulletin from '@/views/news/index'
import newsbulletinList from '@/views/news/list'
import newsbulletinDetail from '@/views/news/detail'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/aaa',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/regionreport',
      name: 'RegionReport',
      component: RegionReport
    },{
      path: '/personreport',
      name: 'PersonReport',
      component: PersonReport
    },{
      path: '/content',
      name: 'Content',
      component: Content
    },{
      path: '/content-employees',
      name: 'ContentEmployees',
      component: ContentEmployees
    },{
      path: '/content-owner',
      name: 'ContentOwner',
      component: ContentOwner
    },
    {
      path: '/newsbulletin',
      name: 'newsbulletin',
      component: newsbulletin,
      children: [{
        path: 'newsbulletinlist',
        name: 'newsbulletinlist',
        meta: {
            auth: true
        },
        component: newsbulletinList
      },{
        path: 'newsbulletindetail',
        name: 'newsbulletindetail',
        meta: {
            auth: true
        },
        component: newsbulletinDetail
      }]
    },
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js